import { Checkbox } from '../../ui/checkbox';
import type { FieldControlProps } from '../field-control';

/** `boolean`: a checkbox. The label is rendered by the form row (to the right). */
export function BooleanControl(props: FieldControlProps) {
  const { field, value, onChange, onBlur, id, disabled, invalid, describedBy } = props;
  return (
    <Checkbox
      id={id}
      checked={value === true}
      onCheckedChange={(checked) => onChange(checked === true)}
      onBlur={onBlur}
      disabled={disabled || field.readOnly}
      aria-invalid={invalid || undefined}
      aria-describedby={describedBy}
      aria-required={field.required || undefined}
    />
  );
}
